<div class="container coustom_container">
    <div class="row">
        <div class="col-12 ">
            <span class="title_header_bar">Portal Notifications </span>
        </div>
    </div>
    <div class="card card_content">
        <form [formGroup]="form">

            <div class="row d-flex justify-content-between align-items-center flex-wrap grid-margin">

                <div class="col-md-4">
                    <!-- <button type="button" class="btn btn-secondary mr-2" (click)="clearFilter()">
                        <i class="fa fa-refresh"></i> Refresh
                    </button> -->
                    <app-button (refreshClicked)="clearFilter()"></app-button>

                    <button type="button" class="btn excel_btn text-nowrap mr-2" (click)="exportAsXLSX()">
                        <i class="fa fa-file-excel"></i> Export
                    </button>
                </div>
                <div class="col-5 d-flex">
                    <button type="button" class="btn btn-primary mr-3  d-flex"
                        (click)="Exceluploadshow = !Exceluploadshow">
                        <ng-container *ngIf="!Exceluploadshow">
                            <app-icon name="arrow-rounded-down-12x7" size="12x7"></app-icon>
                        </ng-container>
                        <ng-container *ngIf="Exceluploadshow">
                            <app-icon name="arrow-rounded-up-13x8" size="13x8"></app-icon>
                        </ng-container>
                        <span class="ml-2">Upload Excel</span>
                    </button>
                    <button type="button" class="btn btn-primary mr-3  d-flex" (click)="filtershow = !filtershow">
                        <ng-container *ngIf="!filtershow">
                            <app-icon name="arrow-rounded-down-12x7" size="12x7"></app-icon>
                        </ng-container>
                        <ng-container *ngIf="filtershow">
                            <app-icon name="arrow-rounded-up-13x8" size="13x8"></app-icon>
                        </ng-container>
                        <span class="ml-2">Advanced search</span>
                    </button>
                </div>
            </div>
            <div [@detailExpand]="Exceluploadshow ? 'expanded' : 'collapsed'" style="overflow: hidden;">
                <hr>
                <div class="subtitle_header ml-2">Excel Upload</div>
                <form [formGroup]="form">
                    <div class="row">
                        <div class="col-sm-12 col-md-7 mt-4">
                            <div class="col-sm-12 col-md-12 align-self-center"
                                style="display: flex; align-items: center;">
                                <mat-radio-group formControlName="batchProcessModuleType"
                                    style="display: flex !important; flex-direction: row; gap: 35px;">
                                    <mat-radio-button value="2">Debit Order Notification</mat-radio-button>
                                    <mat-radio-button class="ml-2" value="3">Failed Debit
                                        Orders</mat-radio-button>
                                    <mat-radio-button class="ml-2" value="4">Suspend</mat-radio-button>

                                </mat-radio-group>
                            </div>
                        </div>
                        <div class="col-xl-5 mt-3">
                            <div class="padd-right-file" style="display: flex;">
                                <mat-form-field appearance="fill" hideRequiredMarker (click)="selectFile()">
                                    <mat-label>Attachment</mat-label>
                                    <input matInput id="AttachmentFileName" placeholder="Select Attachment"
                                        formControlName="AttachmentFileName" autocomplete="off" specialIsAlphaNumeric
                                        class="col-10" autocomplete="off" readonly>
                                </mat-form-field>
                                <button type="button" (click)="selectFile()" *ngIf="!isFileSelected"
                                    class="badge bg-light-blue image-button">
                                    <img src="../../../../assets/Home-Connect/icons/upload-Icon.svg"
                                        style="width: 26px;" />
                                </button>
                                <button type="button" (click)="reset()" *ngIf="isFileSelected"
                                    class="badge bg-light-blue image-button">
                                    <img style="filter: invert(1);width: 26px;"
                                        src="../../../../assets/Home-Connect/icons/delete.svg" />
                                </button>
                            </div>

                        </div>

                    </div>
                    <div class="d-flex justify-content-center button-style mt-4">
                        <button class="btn reset_btn mb-3 mr-3" type="button" (click)="clearFilter()" matButton><i
                                class="fa fa-refresh"></i>Reset</button>
                        <button class="btn btn-secondary mb-3" type="submit" (click)="upload()"
                            matButton>Submit</button>
                    </div>
                </form>
            </div>
            <div [@detailExpand]="filtershow ? 'expanded' : 'collapsed'" style="overflow: hidden;">
                <hr>
                <div class="subtitle_header ml-5">Advanced Search</div>
                <div class="row mx-5">
                    <div class="col-xl-6 mt-4">
                        <mat-form-field class="custom-input" appearance="fill" hideRequiredMarker>
                            <mat-label>Start Date</mat-label>
                            <input matInput [matDatepicker]="startDatePicker" formControlName="startDate" [max]="maxdate"
                                autocomplete="off" placeholder="Select Start Date" class="custom-input-border"
                                (dateChange)="DatePicker('startDate', $event)" (click)="startDatePicker.open()">
                            <mat-datepicker-toggle matSuffix [for]="startDatePicker" style="color:black;">
                                <button mat-icon-button>
                                    <mat-icon>event</mat-icon>
                                </button>
                            </mat-datepicker-toggle>
                            <mat-datepicker #startDatePicker startView="multi-year"></mat-datepicker>
                        </mat-form-field>
                    </div>

                    <div class="col-xl-6 mt-4">
                        <mat-form-field class="custom-input" appearance="fill" hideRequiredMarker>
                            <mat-label>End Date</mat-label>
                            <input matInput [matDatepicker]="endDatePicker" formControlName="endDate" [min]="mindate" [max]="maxdate"
                                autocomplete="off" placeholder="Select End Date" class="custom-input-border"
                                (click)="endDatePicker.open()">
                            <mat-datepicker-toggle matSuffix [for]="endDatePicker" style="color:black;">
                                <button mat-icon-button>
                                    <mat-icon>event</mat-icon>
                                </button>
                            </mat-datepicker-toggle>
                            <mat-datepicker #endDatePicker startView="multi-year"></mat-datepicker>
                        </mat-form-field>
                    </div>


                </div>
                <div class="d-flex justify-content-center button-style mt-4">
                    <button class="btn reset_btn mb-3 mr-3" type="button" (click)="clearFilter()" matButton><i
                            class="fa fa-refresh"></i>Reset</button>
                    <button class="btn btn-secondary mb-3" type="submit" (click)="filter()" matButton> <i class="fa fa-search"></i>  Search</button>
                </div>
            </div>




        </form>

        <div class="table-responsive table-container mt-4 mb-4">
            <mat-table #table [dataSource]="dataSource" class="mat-table">



                <ng-container matColumnDef="CustomerNumber">
                    <mat-header-cell *matHeaderCellDef>Customer Number</mat-header-cell>
                    <mat-cell *matCellDef="let dataField" style="width: 8%;">
                        <p class="text-truncate txtalign">{{dataField.client}}</p>
                    </mat-cell>
                </ng-container>
                <ng-container matColumnDef="Name">
                    <mat-header-cell *matHeaderCellDef> Name</mat-header-cell>
                    <mat-cell *matCellDef="let dataField" style="width: 10%;">
                        <p class="text-truncate txtalign">{{dataField.name}} </p>
                    </mat-cell>
                </ng-container>
                <ng-container matColumnDef="Type">
                    <mat-header-cell *matHeaderCellDef>Type</mat-header-cell>
                    <mat-cell *matCellDef="let dataField" style="width: 10%;">
                        <p class="text-truncate txtalign">{{dataField.moduleType}}</p>
                    </mat-cell>
                </ng-container>
                <ng-container matColumnDef="SentOn">
                    <mat-header-cell *matHeaderCellDef>Sent On</mat-header-cell>
                    <mat-cell *matCellDef="let dataField" style="width: 15%;">
                        <p class="text-truncate txtalign">{{dataField.creationTs}}</p>
                    </mat-cell>
                </ng-container>
                <ng-container matColumnDef="Status">
                    <mat-header-cell *matHeaderCellDef>Status</mat-header-cell>
                    <mat-cell *matCellDef="let dataField" style="width: 10%;">
                        <p class="text-truncate txtalign py-2" [ngClass]="getStatusClass(dataField.processType)">
                            {{dataField.processType}}</p>
                    </mat-cell>
                </ng-container>
                <ng-container matColumnDef="View">
                    <mat-header-cell *matHeaderCellDef>View</mat-header-cell>
                    <mat-cell *matCellDef="let dataField" style="width: 8%;">
                        <div class="row justify-content-center align-items-center txtalign">



                            <div class=" col-2 p-0">
                                <i style="cursor: pointer; font-size: 18px; color: blue;" class="fa fa-eye mr-4"
                                    *ngIf="dataField.processType!='Failed'" title="view" (click)="view(dataField)"></i>
                                <i style="cursor: pointer; font-size: 18px; color: #9a00da;" class="fa fa-download "
                                    (click)="download(dataField.batchProcessId)" title="download"></i>
                            </div>


                        </div>
                    </mat-cell>
                </ng-container>




                <mat-header-row *matHeaderRowDef="displayedColumns; sticky:true"></mat-header-row>

                <mat-row *matRowDef="let row; columns: displayedColumns;  " matRipple>
                </mat-row>
            </mat-table>
            <div *ngIf="data.length == 0" class="no-data-message">
                <p>No data found</p>
            </div>
        </div>
        <div class="table_pagenation">
            <mat-paginator #paginator [length]="dataSource!==null && dataSource.filteredData.length" [pageIndex]="0"
                [pageSize]="10" [pageSizeOptions]="[10, 25, 50, 100]">
            </mat-paginator>
        </div>
    </div>


  
</div>